import {connect} from 'react-redux';
import {RotorAdapters as Component} from './RotorAdapters';
import {
  createRotorAdapters,
  setHeld,
  setHeldObject,
  showMoveMenu,
  setMoveMenu,
  hideAllControls,
  pushInteractions,
  setRotorAdaptersControlVisibility,
  setRotorAdaptersOnShelf,
  setRotorAdaptersInScene,
  setRotorAdaptersHeld,
  onMicrocentrifugeInsertRotor,
  onItemDropCentrifugeMC,
} from '@learningblocks/protocol-redux/lib/Actions';


function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("rotorAdapters") &&
     state.notebook.protocolSection.scene.apparatus.rotorAdapters.some(
       rotorAdapters => rotorAdapters.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.rotorAdapters[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.rotorAdapters[ownProps.id-1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      //aria: ownProps.aria,
      numberOfAdapters: state.notebook.protocolSection.scene.apparatus.rotorAdapters.length,
      inScene: state.notebook.protocolSection.scene.apparatus.rotorAdapters[ownProps.id-1].inScene,
       interactions: state.notebook.protocolSection.scene.interactions,
       target: state.notebook.protocolSection.scene.lastDrop.lastTarget,
       interactionProps: {
         gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
         transilluminator: state.notebook.protocolSection.scene.apparatus.transilluminator,
         microcentrifuge: state.notebook.protocolSection.scene.apparatus.microcentrifuge,
       },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {

  return {
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setRotorAdaptersControlVisibility: (data) => {
      dispatch(setRotorAdaptersControlVisibility(data))
    },
    setRotorAdaptersOnShelf: (data) => {
      dispatch(setRotorAdaptersOnShelf(data))
    },
    setRotorAdaptersInScene: (data) => {
      dispatch(setRotorAdaptersInScene(data))
    },
    createRotorAdapters: (data) => {
      dispatch(createRotorAdapters(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setRotorAdaptersHeld: (data) => {
      dispatch(setRotorAdaptersHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    onMicrocentrifugeInsertRotor: (data) => {
      dispatch(onMicrocentrifugeInsertRotor(data))
    },

    onItemDropCentrifugeMC: (data) => {
      dispatch(onItemDropCentrifugeMC(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },

  };
}

export const RotorAdapters = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
